import { useState, useMemo } from 'react';

import AddUserDialog from './AddUserDialog';
import { useLoadUserQuery } from './redux/databaseView';

import {
  Box,
  Button
} from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';


export function UserManagement() {

  const [dlgOpen, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const data = useLoadUserQuery();


  const userColumns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      minWidth: 180
    },
    {
      field: 'supervisorName',
      headerName: 'Supervisor',
      flex: 1,
      minWidth: 180
    },
    {
      field: 'areas',
      headerName: 'Responsibilities',
      flex: 2,
      minWidth: 300
    }
  ];


  const rows = useMemo(() => {

    if (!data.isSuccess) {
      return [];
    }

    return data.data.data.map((entry) => {

      let responsibilities = {};

      try {
        responsibilities = entry.areas
          ? JSON.parse(entry.areas)
          : {};
      }
      catch (error) {
        console.error(
          'Unable to parse responsibilities',
          entry,
          error
        );
      }

      const responsible = Object
        .keys(responsibilities)
        .filter((key) => !!responsibilities[key]);

      return {
        ...entry,
        areas: responsible.join(', ')
      };
    });

  }, [
    data.isSuccess,
    data.data
  ]);


  function addNew() {
    setSelectedValue(null);
    setOpen(true);
  }


  function selectRow(params) {
    setSelectedValue(params);
    setOpen(true);
  }


  function handleClose() {
    setOpen(false);
  }


  if (!data.isSuccess) {
    return null;
  }


  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        px: 2,
		pt: 5
      }}
    >

      <AddUserDialog
        selectedValue={selectedValue}
        open={dlgOpen}
        onClose={handleClose}
        title={
          selectedValue
            ? 'Edit User'
            : 'Add User'
        }
      />


      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1
        }}
      >
        <Button
          variant="outlined"
          onClick={addNew}
        >
          Add User
        </Button>
      </Box>


      <DataGrid
        rows={rows}
        columns={userColumns}
        pagination={false}
        hideFooter

        onRowClick={selectRow}

        sx={{
          flex: 1,
          minHeight: 0,
          border: 0,

          '& .MuiDataGrid-row': {
            cursor: 'pointer'
          },

          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none'
          },

          '& .MuiDataGrid-cell:active': {
            outline: 'none'
          },

          '& .MuiDataGrid-cell.Mui-focusVisible': {
            outline: 'none'
          }
        }}
      />

    </Box>
  );
}